/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostAsyncType =
  (typeof StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostAsyncType)[keyof typeof StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostAsyncType];

export const StagePaywallAsyncVisitUserProgressionFlowManualTestPaywallAsyncVisitNoriConversationIdPostAsyncType =
  {
    ASYNC_RX: "ASYNC_RX",
    ASYNC_DX: "ASYNC_DX",
    RX_RENEWAL: "RX_RENEWAL",
  } as const;
